import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import Colour from 'components/utils/Colour'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import LoyaltyProgramNameLogo from 'loyalty/components/LoyaltyProgramNameLogo'
import { rem } from 'polished'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import getTasteOfGoldPromoCampaign from 'takeovers/tasteOfGoldTakeover/selectors/getTasteOfGoldPromoCampaign'
import { TasteOfGoldPromoCard } from 'takeovers/tasteOfGoldTakeover/components/TasteOfGoldPromoStyles'
import TasteOfGoldPromoContent from 'takeovers/tasteOfGoldTakeover/components/TasteOfGoldPromoContent'

const HeroSection = styled.div`
  padding: ${rem(60)} 0;
  background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
`

const PromoWrapper = styled.div`
  margin-top: ${rem(24)};
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserBronzeHero(props: Props) {
  const { onActivate } = props
  const intl = useIntl()
  const firstName = useAppSelector(state => state.auth.account.givenName)
  const isTasteOfGoldActive = !!useAppSelector(getTasteOfGoldPromoCampaign)

  const invitedHeading = intl.formatMessage({
    id: '1BNSgQoTo7zZUSWQFyjP',
    defaultMessage: 'You’re invited to join the ultimate rewards program to elevate every escape.',
    description: 'Subheading inviting bronze tier user to join the loyalty rewards program',
  })

  const activateMembershipCta = intl.formatMessage({
    id: 'j1jvLWRGgtql75oheDrI',
    defaultMessage: 'Activate your free membership',
    description: 'CTA button to activate free loyalty membership on bronze hero',
  })

  return <HeroSection>
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={16} style={{ position: 'relative' }}>
        <LoyaltyProgramNameLogo width={104} />
        <Group
          direction="vertical"
          tabletDirection="horizontal"
          tabletHorizontalAlign="space-between"
          gap={24}
          tabletGap={16}
        >
          <VerticalSpacer gap={16}>
            <Heading variant="heading1" format="propercase">
              <FormattedMessage
                id="FCbkdsU6cfuBaDeeYM4p"
                defaultMessage="{hasFirstName, select, true {<i>{firstName}</i>, } other {}}you’ve unlocked{br}<bronze>Bronze status</bronze>"
                description="Heading welcoming user who has unlocked Bronze loyalty tier status"
                values={{
                  hasFirstName: firstName ? 'true' : 'false',
                  firstName,
                  i: (chunks) => <i>{chunks}</i>,
                  br: <br />,
                  bronze: (chunks) => <Colour value="tier-bronze-light-contrast">{chunks}</Colour>,
                }}
              />
              <Heading variant="heading4">
                {invitedHeading}
              </Heading>
            </Heading>
          </VerticalSpacer>
          <Group
            direction="vertical"
            horizontalAlign="start"
            tabletHorizontalAlign="end"
            tabletVerticalAlign="end"
            gap={16}
          >
            <TextButton kind="primary" onClick={onActivate}>
              {activateMembershipCta}
            </TextButton>
          </Group>
        </Group>
      </VerticalSpacer>
      {isTasteOfGoldActive && <PromoWrapper><TasteOfGoldPromoCard><TasteOfGoldPromoContent layout="horizontal" size="medium" /></TasteOfGoldPromoCard></PromoWrapper>}
    </LayoutContainer>
  </HeroSection>
}

export default LoyaltyUserBronzeHero
